import React from "react";
import { QueriesBanner } from "../../../Assets";
import ReplyQueriesForm from "./ReplyQueriesForm";
import { useEffect } from "react";
import TicketDetails from "./TicketDetails";

const ReplyQueries = ({
  selectedQueryId,
  setSelectedQueryId,
  ticketDetailsData,
  repliesData,
  fetchChatList
}) => {
  console.log(repliesData);


  return (
    <div className="reply-queries-main-cover-wrapper">
      <div className="employee-queries-main-cover-wrapper mb-4">
        <div className="row d-flex">
          <div className="col-lg-7">
            {repliesData?.length > 0 ? (
                <div className="ticket-details-cover-wrapper">
                    <TicketDetails repliesData={repliesData} ticketDetailsData={ticketDetailsData} isActiveFooter={false} />
                </div>
            ) : (
              <div className="queries-banner-cover-wrapper">
                <img src={QueriesBanner} alt="Queries banner"></img>
                <div className="queries-note-box">
                  <span className="label label-danger label-sm noteCommon">
                    Note!
                  </span>
                  <ul
                    className="padding-left-50"
                    style={{ marginBottom: 13, listStyleType: "none" }}
                  >
                    <li>
                      Please ensure that file format is one of the following :
                      xls, xlsx, doc, docx, png, jpeg, jpg, pdf
                    </li>
                    <li>Uploaded files should not be greater than 5 MB</li>
                    <li>Maximum Upload limit : 5 files</li>
                  </ul>
                </div>
              </div>
            )}
          </div>
          <div className="col-lg-5">
            <ReplyQueriesForm
              selectedQueryId={selectedQueryId}
              ticketDetailsData={ticketDetailsData}
              fetchChatList={fetchChatList}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReplyQueries;
